export default function Loading() {
  return (
    <div className=" bg-black bg-opacity-25  fixed top-0 right-0 h-screen w-screen z-[9999] flex justify-center items-center">
      <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-5 border-primary"></div>
    </div>
  );
}
export function LoadingItem() {
  return (
    <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-5 border-primary"></div>
  );
}
